import { BillingStageScheduleType, StageScheduleContext } from '~/models';
export const getScheduleLabel = (params)=>{
    const { schedule, context, texts, today } = params;
    switch(schedule.type){
        case BillingStageScheduleType.Manual:
            return {
                kind: 'text',
                label: texts.inline.manual()
            };
        case BillingStageScheduleType.OnEffectiveDate:
            return {
                kind: 'text',
                label: context === StageScheduleContext.ProposalOnEffectiveDate ? texts.inline.onEffectiveDate() : texts.inline.onAcceptance()
            };
        case BillingStageScheduleType.RequiresDateSelection:
            return {
                kind: 'placeholder',
                label: texts.placeholder.selectDate()
            };
        case BillingStageScheduleType.OnDate:
            if (context === StageScheduleContext.Amendment && today && schedule.onDate.date === today) {
                return {
                    kind: 'text',
                    label: texts.inline.today()
                };
            }
            return {
                kind: 'text',
                label: texts.inline.on()
            };
        case BillingStageScheduleType.RelativeToEffectiveDate:
            return {
                kind: 'text',
                label: context === StageScheduleContext.ProposalOnEffectiveDate ? texts.inline.afterEffectiveDate() : texts.inline.afterAcceptance()
            };
    }
};
